<section>
  <div class="form-register mb-2">
    <form novalidate [formGroup]="formInvoiceCashReceipt">
      <div class="row p-1">
        <div class="col fields">
          <app-custom-input-text formControlName="document" [labelText]="'Docum.'"></app-custom-input-text>
        </div>
        <div class="col fields">
          <app-custom-input-decimal [value]="residueValueInMemory" [labelText]="'Vr.Saldo'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col fields">
          <app-custom-input-decimal formControlName="discountValue" [labelText]="'Vr.Descuento'" [required]="true"
            (onChangeNumber)="changeDiscountValue($event)"></app-custom-input-decimal>
        </div>
        <div class="col fields">
          <app-custom-input-decimal formControlName="paidValue" [labelText]="'Vr.Pagado'" [required]="true"
            (onChangeNumber)="calculateValues()"></app-custom-input-decimal>
        </div>
        <div class="col actions-buttons d-flex align-items-end gap-2 mt-2">
          <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
          <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>